import { PaymentIntent } from '@stripe/stripe-js'
import { LegalMatterQuoteFragment, PaymentInfo } from './generated/graphql'

export enum IntentTypes {
  PAYMENT = 'payment',
  SETUP = 'setup',
}

export interface PaymentIntentData {
  clientSecret: string
  returnUrl: string
  metadata?: Record<string, string>
}

export interface SetupIntentData {
  subscriberKey: string
  metadata?: Record<string, string>
}

export interface StripePaymentContextType {
  isDrawerOpen: boolean
  isProcessing: boolean
  error: string | null
  currentIntent: IntentTypes | null
  openPaymentDrawer: (data: PaymentIntentData) => Promise<void>
  openSetupDrawer: (data: SetupIntentData) => Promise<void>
  closeDrawer: () => void
  processPayment: () => Promise<boolean>
  fetchPaymentIntentDetails: (
    clientSecret: string,
  ) => Promise<PaymentIntent | null>
  cardInfo: PaymentInfo | null
  setCardInfo: (info: PaymentInfo | null) => void
  quoteKeyToPay: string | undefined
  setupIntent: string | undefined
  paymentIntentClientSecret: string | undefined
  setupIntentClientSecret: string | undefined
  retrievedPaymentMethodId: string | undefined
}
